let audioCtx = null;

function getAudioContext() {
  const AudioContextClass = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextClass) return null;
  if (!audioCtx) audioCtx = new AudioContextClass();
  return audioCtx;
}

export async function unlockNotificationSound() {
  const ctx = getAudioContext();
  if (!ctx) return false;
  if (ctx.state === 'suspended') await ctx.resume();
  return ctx.state === 'running';
}

const PADROES = {
  suave: [
    { freq: 880, start: 0, dur: 0.09 },
    { freq: 1175, start: 0.11, dur: 0.12 },
  ],
  alerta: [
    { freq: 740, start: 0, dur: 0.10 },
    { freq: 988, start: 0.12, dur: 0.10 },
    { freq: 740, start: 0.24, dur: 0.10 },
  ],
  discreto: [
    { freq: 660, start: 0, dur: 0.10 },
  ],
};

export async function playNotificationSound(config = {}) {
  if (config.ativo === false) return;
  const volume = Math.max(0, Math.min(100, Number(config.volume ?? 60))) / 100;
  if (volume <= 0) return;

  const ctx = getAudioContext();
  if (!ctx) return;
  if (ctx.state === 'suspended') await ctx.resume();
  if (ctx.state !== 'running') return;

  const padrao = PADROES[config.tipo] || PADROES.suave;
  const master = ctx.createGain();
  master.gain.value = 0.16 * volume;
  master.connect(ctx.destination);

  const base = ctx.currentTime;
  padrao.forEach((nota) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.value = nota.freq;
    gain.gain.setValueAtTime(0.0001, base + nota.start);
    gain.gain.exponentialRampToValueAtTime(1, base + nota.start + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, base + nota.start + nota.dur);
    osc.connect(gain);
    gain.connect(master);
    osc.start(base + nota.start);
    osc.stop(base + nota.start + nota.dur + 0.02);
  });
}
